import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
.profile-page {
  box-sizing: border-box;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 30px 38px 46px;
  color: #172033;
  background: radial-gradient(circle at 7% 0%, rgba(124, 58, 237, 0.09), transparent 27%), radial-gradient(circle at 93% 8%, rgba(244, 114, 182, 0.07), transparent 24%), linear-gradient(180deg, #fbfaff 0%, #f7f6fa 100%);
}

.profile-page *,
.profile-page *::before,
.profile-page *::after {
  box-sizing: inherit;
}

button,
input {
  font: inherit;
}

button {
  cursor: pointer;
}

button:disabled {
  cursor: wait;
}

.page-header,
.profile-content {
  width: 100%;
  max-width: 1180px;
  margin-right: auto;
  margin-left: auto;
}

.page-header {
  position: relative;
  display: flex;
  min-height: 82px;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  margin-bottom: 24px;
}

.eyebrow {
  margin: 0 0 7px;
  color: #7c3aed;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.13em;
}

.page-header h1 {
  margin: 0;
  color: #111827;
  font-size: clamp(25px, 2.2vw, 31px);
  font-weight: 900;
  letter-spacing: -0.04em;
}

.header-copy {
  margin: 8px 0 0;
  color: #7c8494;
  font-size: 13px;
}

.header-decoration {
  position: relative;
  width: 138px;
  height: 72px;
  flex: 0 0 138px;
}

.deco-ring {
  position: absolute;
  right: 19px;
  bottom: 5px;
  width: 54px;
  height: 54px;
  border: 9px solid #ede9fe;
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px rgba(124, 58, 237, 0.08);
}

.deco-dot {
  position: absolute;
  border-radius: 50%;
}

.dot-one {
  top: 8px;
  right: 68px;
  width: 14px;
  height: 14px;
  background: #f9a8d4;
}

.dot-two {
  right: 1px;
  bottom: 8px;
  width: 9px;
  height: 9px;
  background: #fcd34d;
}

.deco-spark {
  position: absolute;
  top: 4px;
  right: 3px;
  color: #8b5cf6;
  font-size: 22px;
  transform: rotate(10deg);
}

.profile-content {
  display: grid;
  gap: 16px;
}

.profile-hero,
.settings-card {
  border: 1px solid rgba(228, 222, 238, 0.82);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 14px 38px rgba(61, 43, 88, 0.06);
}

.profile-hero {
  position: relative;
  display: grid;
  grid-template-columns: 148px minmax(0, 1fr) minmax(230px, 284px);
  min-height: 200px;
  align-items: center;
  gap: 30px;
  overflow: hidden;
  padding: 28px 30px;
  border-radius: 20px;
}

.profile-hero::before {
  position: absolute;
  top: -78px;
  left: -46px;
  width: 210px;
  height: 210px;
  border: 34px solid rgba(237, 233, 254, 0.64);
  border-radius: 50%;
  content: "";
  pointer-events: none;
}

.avatar-area,
.hero-copy,
.hero-note {
  position: relative;
  z-index: 1;
}

.avatar-area {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.avatar-button {
  position: relative;
  display: grid;
  width: 112px;
  height: 112px;
  place-items: center;
  padding: 0;
  border: 5px solid #fff;
  border-radius: 50%;
  color: #6d28d9;
  background: linear-gradient(145deg, #ede9fe, #fce7f3);
  box-shadow: 0 0 0 1px #e8e0f5, 0 13px 28px rgba(91, 33, 182, 0.15);
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.avatar-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1), 0 17px 32px rgba(91, 33, 182, 0.18);
}

.avatar-button img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-fallback {
  font-size: 39px;
  font-weight: 900;
}

.camera-badge {
  position: absolute;
  right: -2px;
  bottom: 3px;
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 3px solid #fff;
  border-radius: 50%;
  color: #fff;
  background: #7c3aed;
  box-shadow: 0 5px 12px rgba(91, 33, 182, 0.24);
}

.camera-badge svg {
  width: 15px;
  height: 15px;
}

.avatar-saving {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: rgba(55, 35, 81, 0.62);
  backdrop-filter: blur(2px);
}

.avatar-saving .button-spinner {
  width: 22px;
  height: 22px;
}

.remove-image-button {
  margin-top: 11px;
  padding: 2px 5px;
  border: 0;
  color: #9a6f82;
  font-size: 10px;
  font-weight: 800;
  background: transparent;
}

.remove-image-button:hover:not(:disabled) {
  color: #e11d48;
}

.avatar-help {
  margin-top: 11px;
  color: #8d7aa3;
  font-size: 10px;
  font-weight: 800;
}

.hero-copy {
  min-width: 0;
}

.hero-title-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.welcome-label {
  display: block;
  margin-bottom: 4px;
  color: #8b5cf6;
  font-size: 10px;
  font-weight: 900;
}

.hero-title-row h2 {
  margin: 0;
  color: #182033;
  font-size: 25px;
  font-weight: 900;
  letter-spacing: -0.04em;
}

.role-badge {
  display: inline-flex;
  align-items: center;
  margin-bottom: 3px;
  padding: 4px 8px;
  border-radius: 999px;
  color: #be185d;
  font-size: 9px;
  font-weight: 900;
  background: #fdf2f8;
}

.role-badge.admin {
  color: #6d28d9;
  background: #f5f3ff;
}

.hero-copy > p {
  margin: 8px 0 0;
  overflow: hidden;
  color: #6b7280;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 17px;
}

.profile-meta span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border: 1px solid #ede9f2;
  border-radius: 9px;
  color: #667085;
  font-size: 9px;
  font-weight: 800;
  background: #faf9fc;
}

.profile-meta svg {
  width: 13px;
  height: 13px;
  color: #8b5cf6;
}

.hero-note {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 16px;
  border: 1px solid #ede9fe;
  border-radius: 14px;
  background: linear-gradient(145deg, #faf8ff, #fffafe);
}

.note-icon {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  place-items: center;
  border-radius: 10px;
  color: #7c3aed;
  background: #ede9fe;
}

.note-icon svg {
  width: 18px;
  height: 18px;
}

.hero-note strong {
  display: block;
  color: #42334f;
  font-size: 11px;
  font-weight: 900;
  line-height: 1.45;
}

.hero-note p {
  margin: 5px 0 0;
  color: #978b9e;
  font-size: 9px;
  line-height: 1.55;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.settings-card {
  min-width: 0;
  overflow: hidden;
  border-radius: 18px;
}

.card-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 22px 17px;
  border-bottom: 1px solid #f0edf3;
}

.heading-icon {
  display: grid;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  place-items: center;
  border-radius: 11px;
}

.heading-icon.violet {
  color: #7c3aed;
  background: #f1edff;
}

.heading-icon.rose {
  color: #e11d48;
  background: #fff1f2;
}

.heading-icon svg {
  width: 20px;
  height: 20px;
}

.card-heading h2 {
  margin: 0;
  color: #20283a;
  font-size: 15px;
  font-weight: 900;
  letter-spacing: -0.02em;
}

.card-heading p {
  margin: 4px 0 0;
  color: #98a2b3;
  font-size: 10px;
}

.settings-form {
  display: flex;
  min-height: 432px;
  flex-direction: column;
  gap: 16px;
  padding: 20px 22px 0;
}

.form-field {
  display: block;
}

.form-field > span {
  display: block;
  margin-bottom: 7px;
  color: #4b5565;
  font-size: 10px;
  font-weight: 900;
}

.form-field > span em {
  color: #7c3aed;
  font-style: normal;
}

.form-field input {
  width: 100%;
  height: 42px;
  padding: 0 12px;
  border: 1px solid #dfe3eb;
  border-radius: 10px;
  outline: 0;
  color: #263145;
  font-size: 11px;
  background: #fff;
  transition: border-color 150ms ease, box-shadow 150ms ease, background 150ms ease;
}

.form-field input:focus {
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.09);
}

.form-field input::placeholder {
  color: #b3bac6;
}

.form-field.readonly input {
  padding-left: 39px;
  color: #8a94a6;
  cursor: not-allowed;
  background: #f7f8fa;
}

.input-with-icon {
  position: relative;
}

.input-with-icon svg {
  position: absolute;
  top: 50%;
  left: 13px;
  z-index: 1;
  width: 16px;
  height: 16px;
  color: #a0a8b5;
  transform: translateY(-50%);
}

.form-field small {
  display: block;
  margin-top: 6px;
  color: #a1a8b4;
  font-size: 9px;
}

.card-actions {
  display: flex;
  min-height: 70px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: auto -22px 0;
  padding: 14px 22px;
  border-top: 1px solid #f0edf3;
  background: #fcfbfd;
}

.card-actions p {
  margin: 0;
  color: #9aa2af;
  font-size: 9px;
  line-height: 1.45;
}

.primary-button,
.secondary-action-button {
  display: inline-flex;
  height: 38px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 900;
  transition: transform 150ms ease, box-shadow 150ms ease, opacity 150ms ease;
}

.primary-button {
  border: 0;
  color: #fff;
  background: linear-gradient(135deg, #7c3aed, #8b5cf6);
  box-shadow: 0 8px 18px rgba(124, 58, 237, 0.2);
}

.secondary-action-button {
  border: 1px solid #fecdd3;
  color: #be123c;
  background: #fff;
}

.primary-button:hover:not(:disabled),
.secondary-action-button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.secondary-action-button:hover:not(:disabled) {
  border-color: #fda4af;
  background: #fff7f8;
}

.primary-button:disabled,
.secondary-action-button:disabled {
  opacity: 0.58;
}

.primary-button svg,
.secondary-action-button svg {
  width: 14px;
  height: 14px;
}

.button-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: profile-spin 650ms linear infinite;
}

.skeleton-card {
  pointer-events: none;
}

.skeleton {
  display: block;
  overflow: hidden;
  border-radius: 8px;
  background: linear-gradient(90deg, #f0edf4 25%, #f8f6fa 45%, #f0edf4 65%);
  background-size: 220% 100%;
  animation: profile-shimmer 1.4s ease-in-out infinite;
}

.skeleton-avatar {
  width: 108px;
  height: 108px;
  border-radius: 50%;
}

.skeleton-copy {
  display: grid;
  gap: 12px;
}

.skeleton-title {
  width: 190px;
  height: 24px;
}

.skeleton-line {
  width: 250px;
  height: 11px;
}

.skeleton-short {
  width: 150px;
  height: 28px;
}

.skeleton-heading {
  width: 170px;
  height: 35px;
  margin: 20px 22px 16px;
}

.skeleton-field {
  height: 58px;
  margin: 0 22px 16px;
}

@keyframes profile-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes profile-shimmer {
  to {
    background-position-x: -220%;
  }
}
@media (max-width: 980px) {
  .profile-hero {
    grid-template-columns: 130px minmax(0, 1fr);
  }
  .hero-note {
    display: none;
  }
  .card-actions {
    align-items: flex-end;
    flex-direction: column;
  }
}
@media (max-width: 760px) {
  .profile-page {
    padding: 24px max(20px, env(safe-area-inset-right)) max(38px, env(safe-area-inset-bottom)) max(20px, env(safe-area-inset-left));
  }
  .header-decoration {
    display: none;
  }
  .settings-grid {
    grid-template-columns: 1fr;
  }
  .settings-form {
    min-height: 0;
  }
}
@media (max-width: 520px) {
  .profile-page {
    padding: 20px max(14px, env(safe-area-inset-right)) max(32px, env(safe-area-inset-bottom)) max(14px, env(safe-area-inset-left));
  }
  .page-header {
    min-height: auto;
    margin-bottom: 19px;
  }
  .header-copy {
    font-size: 11px;
    line-height: 1.55;
  }
  .profile-hero {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 18px;
    padding: 24px 20px;
    text-align: center;
  }
  .profile-hero::before {
    left: 50%;
    transform: translateX(-50%);
  }
  .hero-title-row {
    justify-content: center;
  }
  .profile-meta {
    justify-content: center;
  }
  .card-heading,
  .settings-form {
    padding-right: 17px;
    padding-left: 17px;
  }
  .card-actions {
    align-items: stretch;
    margin-right: -17px;
    margin-left: -17px;
    padding-right: 17px;
    padding-left: 17px;
  }
  .card-actions button {
    width: 100%;
  }
}`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public saving: boolean = false;
    public imageSaving: boolean = false;

    public passwordForm: any = {
        current_password: '',
        new_password: '',
        confirm_password: ''
    };
    public changingPassword: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        const user = await this.fetchProfile();
        if (user) {
            this.user = this.withProfileImage(user);
        }
        await this.service.render();
    }

    public initial() {
        return (this.user?.name || '?').trim().charAt(0) || '?';
    }

    public roleLabel() {
        return this.user?.role === 'admin' ? '관리자' : '일반 멤버';
    }

    public async chooseProfileImage() {
        if (this.saving || this.imageSaving) return;

        let image = '';
        try {
            const selectedImage: any = await this.service.file.read({
                type: 'image',
                accept: 'image/png,image/jpeg,image/webp',
                width: 256,
                quality: 0.82
            });
            image = selectedImage
                ? await this.optimizeProfileImage(selectedImage)
                : '';
        } catch (error) {
            await this.service.modal.error(
                this.errorMessage(
                    error,
                    '이미지를 불러오지 못했습니다. 다른 이미지를 선택해주세요.'
                )
            );
            return;
        }
        if (!image) return;
        if (!/^data:image\/(png|jpe?g|webp);base64,/i.test(image)) {
            await this.service.modal.error('JPG, PNG, WEBP 형식의 이미지를 선택해주세요.');
            return;
        }
        if (image.length > 1024 * 1024) {
            await this.service.modal.error('이미지 용량이 너무 큽니다. 다른 이미지를 선택해주세요.');
            return;
        }

        await this.saveProfileImage(image);
    }

    public async removeProfileImage() {
        if (this.saving || this.imageSaving) return;
        await this.saveProfileImage('');
    }

    private async saveProfileImage(profileImage: string) {
        const previousImage = this.user.profile_image || '';
        this.user.profile_image = profileImage;
        this.imageSaving = true;
        await this.service.render();

        let response: any = null;
        try {
            response = await wiz.call("update_profile", {
                name: (this.user?.name || '').trim(),
                email: (this.user?.email || '').trim().toLowerCase(),
                mobile: (this.user?.mobile || '').trim(),
                profile_image: profileImage
            });
        } catch (error) {
            response = error;
        }
        const { code, data } = this.normalizeResponse(response);

        let savedUser: any = null;
        if (code === 200) {
            savedUser = this.isUserPayload(data)
                ? data
                : await this.fetchProfile();
        }

        this.imageSaving = false;
        if (
            code === 200
            && savedUser
            && (savedUser.profile_image || '') === profileImage
        ) {
            this.user = this.withProfileImage(savedUser);
            this.service.auth.session.profile_image = this.user.profile_image;
            await this.service.modal.success(
                profileImage
                    ? "프로필 이미지가 변경되었습니다."
                    : "프로필 이미지가 삭제되었습니다."
            );
        } else {
            if (savedUser) {
                this.user = {
                    ...this.withProfileImage(savedUser),
                    profile_image: previousImage
                };
            } else {
                this.user.profile_image = previousImage;
            }
            await this.service.modal.error(
                code === 200
                    ? "프로필 이미지가 서버에 저장되지 않았습니다. 새로고침 후 다시 시도해주세요."
                    : this.errorMessage(
                        data,
                        "프로필 이미지를 저장하지 못했습니다. 잠시 후 다시 시도해주세요."
                    )
            );
        }
        await this.service.render();
    }

    public async updateProfile() {
        const name = (this.user?.name || '').trim();
        const email = (this.user?.email || '').trim().toLowerCase();
        const mobile = (this.user?.mobile || '').trim();

        if (name.length < 2 || name.length > 50) {
            await this.service.modal.error("이름은 2~50자로 입력해주세요.");
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            await this.service.modal.error("올바른 이메일 주소를 입력해주세요.");
            return;
        }
        if (mobile.length > 20) {
            await this.service.modal.error("연락처는 20자 이내로 입력해주세요.");
            return;
        }
        if (this.saving || this.imageSaving) return;

        this.user.name = name;
        this.user.email = email;
        this.user.mobile = mobile;
        this.saving = true;
        await this.service.render();

        const response: any = await wiz.call("update_profile", {
            name,
            email,
            mobile
        });
        const { code, data } = this.normalizeResponse(response);

        this.saving = false;

        if (code === 200) {
            const savedUser = this.isUserPayload(data)
                ? data
                : await this.fetchProfile();
            if (savedUser) {
                const currentImage = this.user.profile_image || '';
                this.user = {
                    ...this.user,
                    ...savedUser,
                    profile_image: savedUser.profile_image ?? currentImage
                };
            }
            this.service.auth.session.name = this.user.name;
            this.service.auth.session.email = this.user.email;
            await this.service.modal.success("프로필이 업데이트되었습니다.");
        } else {
            await this.service.modal.error(
                this.errorMessage(data, "업데이트에 실패했습니다.")
            );
        }
        await this.service.render();
    }

    public async changePassword() {
        const { current_password, new_password, confirm_password } = this.passwordForm;

        if (!current_password) {
            await this.service.modal.error("현재 비밀번호를 입력해주세요.");
            return;
        }
        if (!new_password) {
            await this.service.modal.error("새 비밀번호를 입력해주세요.");
            return;
        }
        if (new_password.length < 8) {
            await this.service.modal.error("새 비밀번호는 8자 이상이어야 합니다.");
            return;
        }
        if (new_password !== confirm_password) {
            await this.service.modal.error("새 비밀번호가 일치하지 않습니다.");
            return;
        }
        if (this.changingPassword) return;

        this.changingPassword = true;
        await this.service.render();

        const response: any = await wiz.call("change_password", {
            current_password,
            new_password
        });
        const { code, data } = this.normalizeResponse(response);

        this.changingPassword = false;

        if (code === 200) {
            await this.service.modal.success("비밀번호가 변경되었습니다.");
            this.passwordForm = {
                current_password: '',
                new_password: '',
                confirm_password: ''
            };
        } else {
            await this.service.modal.error(
                this.errorMessage(data, "비밀번호 변경에 실패했습니다.")
            );
        }
        await this.service.render();
    }

    private async optimizeProfileImage(dataUrl: string) {
        if (!dataUrl || dataUrl.length < 180 * 1024) return dataUrl;

        return await new Promise<string>((resolve, reject) => {
            const image = new Image();
            image.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = image.naturalWidth || image.width;
                canvas.height = image.naturalHeight || image.height;
                const context = canvas.getContext('2d');
                if (!context) {
                    reject(new Error('이미지를 처리하지 못했습니다.'));
                    return;
                }
                context.fillStyle = '#ffffff';
                context.fillRect(0, 0, canvas.width, canvas.height);
                context.drawImage(image, 0, 0);
                resolve(canvas.toDataURL('image/jpeg', 0.82));
            };
            image.onerror = () => reject(
                new Error('지원하지 않는 이미지 파일입니다.')
            );
            image.src = dataUrl;
        });
    }

    private async fetchProfile() {
        let response: any = null;
        try {
            response = await wiz.call("get");
        } catch (error) {
            response = error;
        }
        const { code, data } = this.normalizeResponse(response);
        if (code !== 200 || !this.isUserPayload(data)) return null;
        return data;
    }

    private isUserPayload(data: any) {
        return Boolean(
            data
            && typeof data === 'object'
            && !Array.isArray(data)
            && typeof data.id === 'string'
            && typeof data.name === 'string'
            && typeof data.email === 'string'
        );
    }

    private withProfileImage(user: any) {
        return {
            ...user,
            profile_image: user?.profile_image || ''
        };
    }

    private normalizeResponse(response: any) {
        if (response && typeof response.code !== 'undefined') {
            return {
                code: Number(response.code),
                data: response.data
            };
        }

        const body = response?.responseJSON;
        if (body && typeof body.code !== 'undefined') {
            return {
                code: Number(body.code),
                data: body.data
            };
        }

        return {
            code: Number(response?.status || 0),
            data: body || response
        };
    }

    private errorMessage(data: any, fallback: string) {
        const extract = (value: any, depth: number = 0): string => {
            if (!value || depth > 3) return '';
            if (typeof value === 'string') {
                const message = value.trim();
                if (!message) return '';
                if (message.startsWith('{') || message.startsWith('[')) {
                    try {
                        return extract(JSON.parse(message), depth + 1) || message;
                    } catch {
                        return message;
                    }
                }
                if (message.startsWith('<!DOCTYPE') || message.startsWith('<html')) {
                    return '';
                }
                return message;
            }
            if (value instanceof Error) return value.message || '';
            if (typeof value !== 'object') return '';

            const candidates = [
                value.message,
                value.error,
                value.detail,
                value.data,
                value.responseJSON,
                value.responseText
            ];
            for (const candidate of candidates) {
                const message = extract(candidate, depth + 1);
                if (message) return message;
            }
            return '';
        };

        return extract(data) || fallback;
    }
}

export default PageMypageComponent;